import type { Node } from "prosemirror-model";
import { Fragment } from "prosemirror-model";
import { Slice } from "prosemirror-model";
import { Plugin, PluginKey } from "prosemirror-state";

import { customEmojis, fetchCustomEmojis } from "../../fetchCustomEmojis";
import { splitEmojis } from "../../splitEmojis";

import { schema } from "~/client/components/richTextEditor/schema";

const extendedText = (node: Node): Array<Node> => {
  if (!node.textContent.includes(":")) {
    return [node];
  }

  const marks = node.marks;
  const result = splitEmojis(node.textContent, customEmojis())
    .map((item) => {
      if (item.token.length <= 0) {
        return null;
      }

      if (item.url === "") {
        return schema.text(item.token).mark(marks);
      }

      return schema.nodes.emoji.create({ alt: item.token, src: item.url }).mark(marks);
    })
    .filter((node): node is Node => node !== null);

  return result;
};

type Walk = {
  (nodeOrFragment: Fragment): Fragment;
  (nodeOrFragment: Node): Array<Node>;
};

const walk: Walk = (nodeOrFragment: Fragment | Node): any => {
  if (nodeOrFragment instanceof Fragment) {
    const content: Array<Node> = [];
    nodeOrFragment.forEach((node) => content.push(...walk(node)));

    return Fragment.from(content);
  }

  if (nodeOrFragment.isText) {
    return extendedText(nodeOrFragment);
  }

  const content = walk(nodeOrFragment.content);
  return [nodeOrFragment.copy(content)];
};

export const pasteEmojiPlugin = () => {
  fetchCustomEmojis();

  return new Plugin({
    key: new PluginKey("pasteEmojiPlugin"),
    props: {
      transformPasted(slice) {
        const fragment = walk(slice.content);
        return new Slice(fragment, slice.openStart, slice.openEnd);
      },
    },
  });
};
